module.exports = __webpack_public_path__ + "assets/img/ubuntu.976fef56.svg";